// Tidy AI-generated narrative text before it is shown. The model still reaches
// for em dashes and double hyphens even when told not to; swap them for commas
// so the report reads in plain prose.

/**
 * @param {string|null|undefined} text
 * @returns {string} the text with dashes normalised to commas
 */
export function cleanNarrative(text) {
  if (!text) return text || "";
  return text
    .replace(/\s*[—–]\s*/g, ", ") // em / en dash → comma
    .replace(/\s+--+\s+/g, ", ") // spaced double hyphen → comma
    .replace(/\s*,\s*,\s*/g, ", ") // collapse doubled commas
    .replace(/\s+([.,;:])/g, "$1") // no space before punctuation
    .replace(/\(,\s*/g, "(") // ", " right after an opening paren
    .trim();
}
